import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SLIDES = [1, 2, 3, 4, 5, 6].map((n) => `/hero/paragon-hero-${n}.jpg`);

export const HeroSlideshow = () => {
  const [idx, setIdx] = useState(0);
  const [tick, setTick] = useState(0);
  const touchX = useRef(null);
  const go = (d) => { setIdx((i) => (i + d + SLIDES.length) % SLIDES.length); setTick((t) => t + 1); };

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, [tick]);

  return (
    <div className="absolute inset-0" data-testid="hero-slideshow"
      onTouchStart={(e) => { touchX.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => {
        if (touchX.current === null) return;
        const dx = e.changedTouches[0].clientX - touchX.current;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        touchX.current = null;
      }}>
      {SLIDES.map((src, i) => (
        <img key={src} src={src} alt="" data-testid={`hero-slide-${i + 1}`} data-active={i === idx}
          loading={i === 0 ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-in-out"
          style={{ opacity: i === idx ? 1 : 0 }} />
      ))}
      <div className="absolute bottom-6 right-6 lg:right-10 z-20 flex items-center gap-3">
        <button data-testid="hero-prev" aria-label="Previous slide" onClick={() => go(-1)}
          className="h-9 w-9 rounded-full border border-white/25 bg-black/40 backdrop-blur text-white flex items-center justify-center hover:border-yellow-400 hover:text-yellow-400 transition-colors">
          <ChevronLeft className="h-4 w-4" />
        </button>
        <div className="flex gap-1.5">
          {SLIDES.map((s, i) => (
            <button key={s} data-testid={`hero-dot-${i + 1}`} aria-label={`Go to slide ${i + 1}`}
              onClick={() => { setIdx(i); setTick((t) => t + 1); }}
              className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === idx ? "w-6 bg-yellow-400" : "w-1.5 bg-white/40 hover:bg-white/70"}`} />
          ))}
        </div>
        <button data-testid="hero-next" aria-label="Next slide" onClick={() => go(1)}
          className="h-9 w-9 rounded-full border border-white/25 bg-black/40 backdrop-blur text-white flex items-center justify-center hover:border-yellow-400 hover:text-yellow-400 transition-colors">
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
